export default "__VITE_ASSET__DD6b_hA7__"